module.exports = __webpack_public_path__ + "public/images/monster-2.3ffd8fe034f5d0e8b0f5f3e453662b49.png";